
<template>
    <div class="card-body">
        <h6 class="card-title">
          <i class="link-icon" data-feather="folder"></i> Asiento Contable
        </h6>
            <div class="row">
                <div class="input-group col-sm-12">
                    <div class="col-sm-3">
                        <div class="form-check mb-3">
                            <input type="checkbox" v-model="usd" class="form-check-input" id="chk_usd">
                            <label class="form-check-label" for="chk_usd">
                                Registrar asiento en dólares
                            </label>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-check mb-3">
                            <input 
                                type="checkbox" 
                                v-model="use_rate" 
                                class="form-check-input" 
                                id="chk_rate"
                                @change="getUsdRate()"
                                >
                            <label class="form-check-label" for="chk_rate">
                                Usar tasa de cambio
                            </label>
                        </div>
                    </div>                
                    <div class="col-sm-6" v-show="use_rate">
                        <div class="form-check form-check-inline">
                            <input type="radio" v-model="rate_type" class="form-check-input" name="rate_type" id="rad_rate_type" value="C">
                            <label class="form-check-label" for="rad_rate_type">
                                Tasa de compra {{ rate_c }}
                            </label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" v-model="rate_type" class="form-check-input" name="rate_type" id="rad_rate_type1" value="V">
                            <label class="form-check-label" for="rad_rate_type1">
                                Tasa de venta {{ rate_v }}
                            </label>
                        </div>
                    </div>
                </div>                
                <div class="col-sm-3">
                    <div class="mb-3">
                        <label class="form-label">Fecha *</label>
                        <div><date-picker 
                            v-model:value="date"
                            :formatter="momentFormat"
                            @change="getUsdRate()"
                            :disabled-date="disabledAfterToday"
                :class="valorError.date?'errord':''"
                        ></date-picker></div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="mb-3">  
                        <label class="form-label">Tipo de Asiento *</label>
                        <multiselect
                            v-model="transaction_type"
                            :options="transaction_types"
                            track-by="id" 
                            label="name"
                            placeholder="Seleccione"
                            :showLabels="false"
                :class="valorError.tipoasiento?'errord':''"
                        ></multiselect>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-3">
                        <label class="form-label">Descripción *</label>
                        <input v-model="description" 
                        :class="valorError.description?'errord':''" type="text" id="description" class="form-control" required="required">
                    </div>
                </div>
                <div class="col-sm-12">
                    <transaction-items 
                        :coin="coin"
                        :company_id="company_id"
                        :items="items"
                        :usd="usd">
                    </transaction-items>
                </div>        
            </div>
    </div>
    <div class="card-footer text-end">
        <a href="../transactions" class="btn btn-secondary">Regresar</a>        
        <span v-if="id==0">
            <button 
                type="button" 
                class="btn btn-primary"
                :disabled="!canSave" 
                @click="storeTransaction(0)">Guardar
            </button>
            <button 
                type="button" 
                class="btn btn-outline-primary" 
                @click="storeTransaction(1)">Guardar borrador
            </button>            
        </span>
        <span v-else>
            <button 
                type="button" 
                class="btn btn-primary"
                :disabled="!canSave" 
                @click="updateTransaction(0)">Guardar
            </button>
            <button v-if="status==2"
                id="btn_update_draf"
                type="button" 
                class="btn btn-outline-primary" 
                @click="updateTransaction(1)">Guardar borrador
            </button>
        </span>
    </div>
</template>

<script>

import TransactionItems from "./TransactionItems.vue";
import Multiselect from 'vue-multiselect'
import moment from "moment";
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import 'vue-datepicker-next/locale/es';
import axios from "axios";

export default {
    props: [
        'coin',
        'company_id',
        'period',
        'id'
    ],  
    components: {
        Multiselect,
        DatePicker,
        TransactionItems
    },
    data() {
        return {            
            errors:[],
            account_required:false,
            cost_centre_required:[],
            reference_required:false,
            transaction_types:[],
            usd:false,
            use_rate:false,
            rate_type:'V',
            failed_rate:true,
            valorError:{
                date:false,
                tipoasiento:false,
                description:false
            },
            rate:null,
            rate_c:null,
            rate_v:null,
            date: new Date(), 
            transaction_type:null,
            description:"",
            status:null,
            submitting:false,
            items: [
                {
                    'account':0,
                    'cost_centre':0,
                    'reference':'',
                    'description':'',
                    'debit':0,
                    'credit':0
                },
                {
                    'account':0,
                    'cost_centre':0,
                    'reference':'',
                    'description':'',
                    'debit':0,
                    'credit':0
                }                
            ],
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('DD/MM/YYYY') : ''
                },
            }            
        };
    },
    beforeMount() {
        this.getTransactionTypes();
        let close=new Date(this.period.close.split('T')[0]+" 00:00:00")
        let end=new Date(this.period.end.split('T')[0]+" 00:00:00")
        let start=new Date(this.period.start.split('T')[0]+" 00:00:00")
        let fechaFinal=new Date()
        if(start>this.date){
            this.date=start
        }else{
            if(close>=end){
                if(close<=this.date){
                    this.date=close
                }
            }else{
                if(end<=this.date){
                    this.date=end
                }
            }
        }
    },
    mounted() {
        console.log('period.start:', this.period.start);
        console.log('period.end:', this.period.end);
        console.log('period.close:', this.period.close);        
        (this.id>0)?this.getTransaction():'';
        if(this.id==0){
            this.use_rate=true;
            this.getUsdRate();
        }
    },  
    computed: {
        activeItems() {
            return this.items.filter((e, index) =>
            (e.account_obj || e.reference || e.cost_centre_obj || e.description || this.toNumber(e.debit) > 0 || this.toNumber(e.credit) > 0 || index <= 1)
            );
        },
        totals() {
            const debit = this.activeItems.reduce((acc, item) => acc + this.toNumber(item.debit), 0);
            const credit = this.activeItems.reduce((acc, item) => acc + this.toNumber(item.credit), 0);
            return { debit, credit, diff: debit - credit };
        },
        isBalanced() {
            return Math.abs(this.totals.diff) <= 0.0001;
        },
        canSave() {
            const idNum = Number(this.id || 0);
            // Para que "Guardar" NO esté habilitado con 0/0
            const hasAmounts = (this.totals.debit > 0 || this.totals.credit > 0);
            // Nuevo asiento: solo permitir guardar si ya hay montos y está balanceado
            if (idNum === 0) {
                return hasAmounts && this.isBalanced;
            }
            // Editando borrador: exigir balance (y opcionalmente montos)
            if (this.status == 2) {
                return hasAmounts && this.isBalanced;
            }
            // Otros estados: mantener regla de balance + montos
            return hasAmounts && this.isBalanced;
        }
    },
    methods: {
        toNumber(v) {
            if (v === null || v === undefined || v === '') return 0;
            // Si ya viene numérico
            if (typeof v === 'number') return isFinite(v) ? v : 0;
            // A string
            v = String(v).trim();
            if (!v) return 0;
            // Quita moneda, espacios y cualquier cosa que no sea dígito/./,/-
            v = v.replace(/[^\d.,-]/g, '');
            if (!v) return 0;
            const hasDot = v.includes('.');
            const hasComma = v.includes(',');
            // Si trae ambos, asumimos que el ÚLTIMO separador es el decimal
            if (hasDot && hasComma) {
                if (v.lastIndexOf(',') > v.lastIndexOf('.')) {
                    // 10.000,00 -> 10000.00
                    v = v.replace(/\./g, '').replace(',', '.');
                } else {
                    // 10,000.00 -> 10000.00
                    v = v.replace(/,/g, '');
                }
            } else if (hasComma) {
                // 100,00 -> 100.00  |  10.000,00 -> 10000.00
                v = v.replace(/\./g, '').replace(',', '.');
            } else {
                // 10,000 -> 10000 (por si acaso)
                v = v.replace(/,/g, '');
            }
            const n = Number(v);
            return isNaN(n) ? 0 : n;
        },
        validateForm(draf) {    
            this.errors=[];
            this.cost_centre_required=[];
            this.account_required=false;
            this.reference_required=false;
            this.valorError.date=false;
            this.valorError.description=false;
            this.valorError.tipoasiento=false;
            if (this.date == null || this.date == "") {
                this.errors.push('El campo Fecha es obligatorio');
                this.valorError.date=true;
            }
            if (this.description == "") {
                this.errors.push('El campo Descripción es obligatorio');
                this.valorError.description=true;
            }
            
            if (this.failed_rate && this.use_rate) {
                this.errors.push('Debe Haber una Tasa');
            }
            if (draf) {
                this.items.forEach((_, index) => {
                    const e = this.items[index];

                    // reset visual (para que no queden rojos pegados)
                    e.errorreference = false;
                    e.errorcuenta = false;
                    e.errorcost_centro = false;
                    e.errorcredit = false;
                    e.errordebit = false;

                    const isActive =
                    (e.account_obj || e.reference || e.cost_centre_obj || e.description
                        || this.toNumber(e.debit) > 0 || this.toNumber(e.credit) > 0 || index <= 1);

                    e.final = isActive;
                });

                return this.errors.length === 0;
            }
            if (this.transaction_type == null) {
                this.errors.push('El campo Tipo de Asiento es obligatorio');
                this.valorError.tipoasiento=true;
            } 
            this.items.forEach((element, index) => {
                // ✅ Reset SIEMPRE (aunque la línea quede vacía/inactiva)
                this.items[index].final = false;
                this.items[index].errorreference = false;
                this.items[index].errorcuenta = false;
                this.items[index].errorcost_centro = false;
                this.items[index].errorcredit = false;
                this.items[index].errordebit = false;

                const isActive =
                    (element.account_obj || element.reference || element.cost_centre_obj || element.description
                    || this.toNumber(element.debit) > 0 || this.toNumber(element.credit) > 0 || index <= 1);

                // Si la fila está vacía (y no es de las 2 primeras), no valida y queda final=false
                if (!isActive) return;

                // ✅ La fila es válida para “enviar”
                this.items[index].final = true;

                // Validaciones obligatorias
                if (!element.account_obj) {
                    this.account_required = true;
                    this.items[index].errorcuenta = true;
                }

                if (!element.reference) {
                    this.reference_required = true;
                    this.items[index].errorreference = true;
                }

                if (element.account_obj) {
                    if (!element.isdisabled) {
                        if (!element.cost_centre_obj) {
                            this.cost_centre_required.push(index + 1);
                            this.items[index].errorcost_centro = true;
                        }
                    }
                }

                // Validación de montos (debe existir al menos uno)
                const d = this.toNumber(element.debit);
                const c = this.toNumber(element.credit);

                if (d === 0 && c === 0) {
                    this.items[index].errorcredit = true;
                    this.items[index].errordebit = true;
                }
            });
            (this.account_required)
                ?this.errors.push('La cuenta es obligatoria en todos los movimientos')
                :'';
            (this.cost_centre_required.length>0)
                ?this.errors.push('El centro de costo es obligatorio')
                :'';
            (this.reference_required)
                ?this.errors.push('El nro de documento obligatorio en todos los movimientos')
                :'';
            if (this.activeItems.length < 2) {
                this.errors.push('El asiento debe tener al menos 2 movimientos');
            }

            var total_debit = this.activeItems.reduce((acc, item) => acc + this.toNumber(item.debit), 0);
            var total_credit = this.activeItems.reduce((acc, item) => acc + this.toNumber(item.credit), 0);

            if (draf == 0 && Math.abs(total_debit - total_credit) > 0.0001) {
                this.errors.push(`El total débito ${total_debit} debe ser igual al total crédito ${total_credit}`);
            }
            return (this.errors.length>0)?false:true;        
        },        
        getUsdRate() {
            if (!this.use_rate) {
                this.failed_rate = false;
                this.rate_c = null;
                this.rate_v = null;
                return;
            }
            if (!this.date || !(this.date instanceof Date)) {
                this.failed_rate = true;
                return;
            }
            axios({
                method: 'post',
                url: '../get_usd_rate',
                data: { date: this.date.toISOString().slice(0, 10) }
            }).then((response) => {
                this.failed_rate = false;
                this.rate_c = response.data.rate_c;
                this.rate_v = response.data.rate_v;
            }).catch((error) => {
                this.failed_rate = true;
                console.log(error);
            });
        },
        getTransactionTypes(){
            axios.get('../api/companies/'+this.company_id+'/transaction_types')
            .then((response) => {
                this.transaction_types = response.data.data;
            })
            .catch( resonse => {
                console.log('error');
            })
        },
        getTransaction(){
            axios.get('../api/transactions/'+this.id+'/vue')
            .then((response) => {
                //seteo los campos del formulario
                this.date= new Date(response.data.date);
                //this.transaction_type = this.transaction_types.find(opcion => opcion.id === response.data.transaction_type_id);
                this.usd = (parseInt(response.data.usd))?true:false;
                this.use_rate = (parseInt(response.data.use_rate))?true:false;
                (this.use_rate)?this.getUsdRate():'';
                this.rate_type = response.data.rate_type;
                this.transaction_type = response.data.transaction_type_obj;
                this.description = response.data.description;
                this.items=response.data.detail.map((Datos)=>{
                    let disables=true;
                    if(Datos.account_obj){
                        if(Number(Datos.account_obj.cost_centre)){
                            disables=false
                        }
                    }
                    return({
                        ...Datos,
                        isdisabled:disables,
                        debit:String(Datos.debit).includes(".")?Datos.debit:String(Datos.debit)+".00",
                        credit:String(Datos.credit).includes(".")?Datos.credit:String(Datos.credit)+".00"
                    })
                });
                
                this.status=response.data.status;
            })
            .catch( resonse => {
                console.log(resonse);
            })
        },
        storeTransaction(draf){
            if (!this.date || !(this.date instanceof Date)) {
                this.toast('error', 3000, 'Fecha inválida');
                return;
            }
            const offset = this.date.getTimezoneOffset()
            var yourDate = new Date(this.date.getTime() - (offset*60*1000))
            if(this.validateForm(draf)){
                var url= '../transactions';
                axios.post(url, {
                    company_id:this.company_id,
                    period_id:this.period.id,
                    usd:(this.usd)?1:0,
                    use_rate:(this.use_rate)?1:0,
                    rate_type:this.rate_type,
                    rate:(this.rate_type=='V')?this.rate_v:this.rate_c,
                    date: yourDate.toISOString().split('T')[0],
                    transaction_type: this.transaction_type?.id,
                    description: this.description,
                    draf:draf,
                    items:JSON.stringify(this.items.filter((datof)=>datof.final).map((elements)=>{
                        let valorCost_centr=0
                        let account_obj=0
                        if(!elements.isdisabled){
                            if(elements.cost_centre_obj){
                               valorCost_centr=elements.cost_centre_obj.id
                            }
                        }
                        if(elements.account_obj){
                            account_obj=elements.account_obj.id
                        }
                        return {
                            ...elements,
                            account:account_obj,
                            cost_centre:valorCost_centr,
                            debit: this.toNumber(elements.debit),
                            credit: this.toNumber(elements.credit),
                        }
                    })),
                }).then(response => {
                    this.toast('success', 2000, response.data.message);
                    this.resetForm();
                }).catch(error => {
                    this.toast('error', 3000, error.response.data.message);
                })
            }else{
                let errorsHtml='';
                this.errors.forEach(element => {
                    errorsHtml += '<li>' + element + '</li>';
                    this.toast('error', 5000, errorsHtml);
                    //console.log(element);
                });
            }
        },
        updateTransaction(draf){
            if (!this.date || !(this.date instanceof Date)) {
                this.toast('error', 3000, 'Fecha inválida');
                return;
            }
            if(this.validateForm(draf)){
                
                const offset = this.date.getTimezoneOffset()
                var yourDate = new Date(this.date.getTime() - (offset*60*1000))
                //pasar el objs a los ids
                var url= '../transactions/'+this.id;
                axios.put(url, {
                    usd:(this.usd)?1:0,
                    use_rate:(this.use_rate)?1:0,
                    rate_type:this.rate_type,
                    rate:(this.rate_type=='V')?this.rate_v:this.rate_c,                    
                    date: yourDate.toISOString().split('T')[0],
                    transaction_type: this.transaction_type?.id,
                    description: this.description,
                    draf:draf,
                    items:JSON.stringify(this.items.filter((datof)=>datof.final).map((elements)=>{
                        let valorCost_centr=0
                        let account_obj=0
                        if(!elements.isdisabled){
                            if(elements.cost_centre_obj){
                               valorCost_centr=elements.cost_centre_obj.id
                            }
                        }
                        if(elements.account_obj){
                            account_obj=elements.account_obj.id
                        }
                        return {
                            ...elements,
                            account:account_obj,
                            cost_centre:valorCost_centr,
                            debit: this.toNumber(elements.debit),
                            credit: this.toNumber(elements.credit),
                        }
                    })),
                }).then(response => {
                    this.toast('success', 2000, response.data.message);
                    this.errors=[];
                    this.submitting=false;
                    $('#btn_update_draf').hide();
                }).catch(error => {
                    this.toast('error', 3000, error.response.data.message);
                })
            }else{
                let errorsHtml='';
                this.errors.forEach(element => {
                    errorsHtml += '<li>' + element + '</li>';
                    this.toast('error', 5000, errorsHtml);
                    //console.log(element);
                });
            }
        },
        disabledAfterToday(date) {
            // Normaliza cualquier Date a "YYYY-MM-DD" sin depender de zona horaria
            const toYMD = (d) => {
                if (!d) return null;
                if (d instanceof Date) return d.toISOString().slice(0, 10);
                // si viniera string ISO
                return String(d).slice(0, 10);
            };

            const addDaysYMD = (ymd, days) => {
                // ymd: "YYYY-MM-DD"
                const [y, m, d] = ymd.split('-').map(Number);
                const dt = new Date(Date.UTC(y, m - 1, d));
                dt.setUTCDate(dt.getUTCDate() + days);
                return dt.toISOString().slice(0, 10);
            };

            const todayYMD = toYMD(new Date());

            const startYMD = toYMD(this.period?.start);
            const endYMD   = toYMD(this.period?.end);
            const closeYMD = toYMD(this.period?.close);

            // Si falta algo crítico, por seguridad deshabilita
            if (!startYMD || !endYMD) return true;

            const dateYMD = toYMD(date);
            if (!dateYMD) return true;

            // ✅ límite superior: no futuro y no más allá del fin del periodo
            const maxAllowed = (endYMD < todayYMD) ? endYMD : todayYMD;

            // ✅ límite inferior: inicio del periodo y además > close (close + 1 día)
            let minAllowed = startYMD;
            if (closeYMD) {
                const dayAfterClose = addDaysYMD(closeYMD, 1);
                if (dayAfterClose > minAllowed) minAllowed = dayAfterClose;
            }

            // si por regla no existe rango válido, deshabilita todo
            if (minAllowed > maxAllowed) return true;

            // Deshabilita lo que esté fuera del rango permitido
            return (dateYMD < minAllowed) || (dateYMD > maxAllowed);
        },
        resetForm(){
            this.date = new Date();
            this.transaction_type = null;
            this.description = "";

            this.usd = false;
            this.use_rate = true;
            this.rate_type = 'V';
            this.failed_rate = false;
            this.rate_c = null;
            this.rate_v = null;

            this.items = [
                { account:0, cost_centre:0, reference:'', description:'', debit:0, credit:0 },
                { account:0, cost_centre:0, reference:'', description:'', debit:0, credit:0 }
            ];
        },
        toast(icon, timer, text){
            this.$swal({
                toast: true,
                width: '40em',
                position: 'top-end',
                showConfirmButton: false,
                timer: timer,
                timerProgressBar:true,
                icon: icon,
                html: text       
            });
        }        
    }
};
</script>

<!-- Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style>
.multiselect__input{
    font-size: 12px; /* opcion seleccionada */ 
}


.select-items.multiselect {
    max-width: 225px;
    font-size: 12px; /* opciones desplegables aqui va el width */
}

.multiselect__single{
    font-size: 12px; /* opcion seleccionada */ 
}

.multiselect__single {
  white-space: nowrap;
  overflow: hidden; 
}

.errord{
    border:1px solid #dc3545!important;
    border-color: #dc3545!important;
}
</style>